export type ResourceType = "article" | "video" | "github" | "tool";
export type ResourceVisibility = "public" | "hidden" | "private";
export type ResourceReviewState = "draft" | "needs_review" | "approved" | "needs_info" | "archived";

export type ResourceItem = {
  id: string;
  title: string;
  sourceName: string;
  type: ResourceType;
  category: string;
  summary: string;
  url: string;
  tags: string[];
  visibility: ResourceVisibility;
  reviewState: ResourceReviewState;
  featured: boolean;
  sortOrder: number;
  updatedAt: string;
};

export const resourceTypeLabels: Record<ResourceType, string> = {
  article: "文章",
  video: "教學影片",
  github: "GitHub",
  tool: "工具"
};

export const resources: ResourceItem[] = [
  {
    id: "prompt-design-guide",
    title: "教師 AI 提示詞設計筆記",
    sourceName: "Winnie EdTech Lab",
    type: "article",
    category: "AI 教學應用",
    summary: "整理教師設計 AI 指令時最常用的脈絡、條件、格式與檢核方式，適合作為研習後的延伸閱讀。",
    url: "#resources",
    tags: ["提示詞", "教師研習", "AI應用"],
    visibility: "public",
    reviewState: "approved",
    featured: true,
    sortOrder: 10,
    updatedAt: "2026-09-30"
  },
  {
    id: "classroom-ai-video",
    title: "AI 融入課堂的活動設計示範",
    sourceName: "教學影片",
    type: "video",
    category: "課堂活動",
    summary: "未來可放入 YouTube、研習錄影或短教學影片，讓訪客快速理解工具在真實教學情境中的用法。",
    url: "#resources",
    tags: ["影片", "課堂設計", "示範"],
    visibility: "public",
    reviewState: "approved",
    featured: true,
    sortOrder: 20,
    updatedAt: "2026-09-30"
  },
  {
    id: "edtech-github",
    title: "教育科技開源專案收藏",
    sourceName: "GitHub",
    type: "github",
    category: "開源資源",
    summary: "可整理值得收藏的 GitHub 專案、範例程式或可改作的教學工具，方便教師與開發者延伸使用。",
    url: "#resources",
    tags: ["開源", "GitHub", "Web App"],
    visibility: "public",
    reviewState: "approved",
    featured: false,
    sortOrder: 30,
    updatedAt: "2026-09-30"
  }
];

